import { createContext, useContext } from 'react'

export interface AuthUser {
  id: string
  email: string | null
  display_name: string | null
  admin: boolean
  moderator: boolean
  providers: string[]
}

export interface AuthContextValue {
  user: AuthUser | null
  loading: boolean
  refresh: () => Promise<void>
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within AuthProvider')
  return context
}
